<div class="subheader with-padding flgrow">
    <div class="row">
        <div class='col-lg-3 col-md-3 col-sm-6'>
            <div class="date">
                <input bsDaterangepicker name="dateRange" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChanged($event)" required/>
            </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 relative mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
            <button type="submit" (click)="onClickChangeView(false)"
                [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
                translate>lblSATodayView
            </button>
            <button (click)="onClickChangeView(true)"
                [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class=""
                translate>lblSAWeekView
            </button>
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                (click)='refresh()'>
                <em class="fas fa-sync font15 align-middle"></em>
            </a>
        </div>
    </div>
</div>

<!-- Error Logs Table -->
<div class="container prel">
    <div class="row mt20">
        <div class="col-12">
            <div class="card ">
                <div class="card-header d-flex justify-content-between">
                    <h4 class="card-title" translate>
                        lblExceptionLog
                    </h4>
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive  max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 55px">#</th>
                                <th scope="col" sortable="ControllerName" (sort)="onSort($event)" translate>
                                    lblControllerName </th>
                                <th scope="col" sortable="MethodName" (sort)="onSort($event)" translate>lblMethodName
                                </th>
                                <th scope="col" sortable="MethodType" (sort)="onSort($event)" translate>lblMethodType
                                </th>
                                <th scope="col" sortable="CreatedDate" (sort)="onSort($event)" translate>lblDate</th>
                                <th class="text-center" scope="col" translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="appointmentErrorLogList?.length>0; else load_else">
                                <tr *ngFor="let log of appointmentErrorLogList; let i=index">
                                    <td>{{ i+1 }}</td>
                                    <td>
                                        <ngb-highlight [result]="log.controllerName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="log.methodName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="log.methodType">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="log.createdDate| date : 'short'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="nowrap text-center">
                                        <!-- View Exception Button -->
                                        <a class="ml-2 btn btn-ico" ngbTooltip="{{'lblViewException' | translate}}"
                                            tooltipClass="custom-revert" (click)="viewException(log)" translate>
                                            <em class="fa fa-eye fa-lg"></em>
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>